export default import.meta.ROLLDOWN_FILE_URL_$oUiuAXR7gZMKRQU56HW2w